// WalletConnect's default IndexedDB adapter goes through unstorage/destr, whose
// .cjs entry is treated as a file by this project's webpack 4 build.
function parseStoredValue(value) {
    if (value === null) return undefined;
    try {
        return JSON.parse(value);
    } catch (error) {
        return value === "undefined" ? undefined : value;
    }
}

async function getKeys() {
    const keys = [];
    for (let index = 0; index < localStorage.length; index += 1) {
        keys.push(localStorage.key(index));
    }
    return keys;
}

const walletConnectStorage = {
    getKeys,
    async getEntries() {
        const keys = await getKeys();
        return keys.map((key) => [key, parseStoredValue(localStorage.getItem(key))]);
    },
    async getItem(key) {
        return parseStoredValue(localStorage.getItem(key));
    },
    async setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    async removeItem(key) {
        localStorage.removeItem(key);
    },
};

export default walletConnectStorage;
